'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var key = require('interface-datastore/key');

var debug = require('debug');

var toString = require('uint8arrays/to-string');

var fromString = require('uint8arrays/from-string');

var level = require('./utils/level.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = debug__default["default"]('ipfs:repo:version');
var versionKey = new key.Key('version');

function version(store) {
  return {
    exists: function exists() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", level.hasWithFallback(versionKey, store.has.bind(store), store));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    get: function get() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var buf;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return level.getWithFallback(versionKey, store.get.bind(store), store.has.bind(store), store);

              case 2:
                buf = _context2.sent;
                return _context2.abrupt("return", parseInt(toString.toString(buf), 10));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    set: function set(version) {
      return store.put(versionKey, fromString.fromString(String(version)));
    },
    check: function check(expected) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var version, compatibleVersion;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.get();

              case 2:
                version = _context3.sent;
                log('comparing version: %s and %s', version, expected);
                compatibleVersion = version === 6 && expected === 7 || expected === 6 && version === 7;
                return _context3.abrupt("return", version === expected || compatibleVersion);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  };
}

exports.version = version;